module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-05.c76d3bc6.png";